export default __webpack_public_path__ + "static/stars_lake-2d8d69af2830d18cf144b7dfdbae3287.jpg";